import { render, staticRenderFns } from "./List-Center.vue?vue&type=template&id=b2de7a02"
import script from "./List-Center.vue?vue&type=script&lang=js"
export * from "./List-Center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports